import { render } from "./Parrilla3Productos.vue?vue&type=template&id=9949527a"
import script from "./Parrilla3Productos.vue?vue&type=script&lang=js"
export * from "./Parrilla3Productos.vue?vue&type=script&lang=js"

import "./Parrilla3Productos.vue?vue&type=style&index=0&id=9949527a&lang=css"

import exportComponent from "/Users/anfloman/Desktop/ComponentesAlgoritmica/TemaWordpress/tema/vuejs/ParrillaPrecios/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__